import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class CavvLookUpSample extends Component {
    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }
    
    render() {
        const { storeId, apiToken, cres, selectedProgLangId } = this.props;

        switch(selectedProgLangId) {
            case _DOTNET:
                return (
                    <pre className="sampleCode">
{`using System;
using Moneris;

public class TestCanadaMpiCavvLookup
{
 public static void Main(string[] args)
 {
  string store_id = "`}{this.getValue(storeId, "storeId")}{`";
  string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
  string processing_country_code = "CA";

  //BASE64 Encoded CRes value returned from response at 
  //completion of challenge flow.

  string cres = "${cres}";

  MpiCavvLookup mpiCavvLookup = new MpiCavvLookup();    
  mpiCavvLookup.SetCRes(cres);

  HttpsPostRequest mpgReq = new HttpsPostRequest();
  mpgReq.SetProcCountryCode(processing_country_code);

  mpgReq.SetTestMode(true); 
  //false or comment out this line for production transactions

  mpgReq.SetStoreId(store_id);
  mpgReq.SetApiToken(api_token);
  mpgReq.SetTransaction(mpiCavvLookup);
  mpgReq.Send();

  try
  {
   Receipt receipt = mpgReq.GetReceipt();

   Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
   Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
   Console.WriteLine("Message = " + receipt.GetMessage());
   Console.WriteLine("ThreeDSServerTransID = " + receipt.GetMpiThreeDSServerTransID());
   Console.WriteLine("TransStatus = " + receipt.GetMpiTransStatus());
   Console.WriteLine("ChallengeCompletionIndicator = " + receipt.GetMpiChallengeCompletionIndicator());

   Console.WriteLine("Cavv = " + receipt.GetMpiCavv());
   Console.WriteLine("ECI = " + receipt.GetMpiEci());
  }
  catch (Exception e)
  {
   Console.WriteLine(e);
  }
 }
}
`}
                </pre>)

        case _JAVA:
            return (
                <pre className="sampleCode">
{`package Canada;

import JavaAPI.*;

public class TestCanadaMpiCavvLookup
{ 
 public static void main(String[] args)
 { 
  String store_id = "`}{this.getValue(storeId, "storeId")}{`";
  String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
  String processing_country_code = "CA";
  //BASE64 Encoded CRes value returned from response at completion of challenge flow.
  String cres = "${cres}";
  MpiCavvLookup mpiCavvLookup = new MpiCavvLookup();
  mpiCavvLookup.setCRes(cres);

//*****************OPTIONAL VARIABLES***********************
  HttpsPostRequest mpgReq = new HttpsPostRequest();
  mpgReq.setProcCountryCode(processing_country_code);
  mpgReq.setTestMode(true); //false or comment out this line for production transactions
  mpgReq.setStoreId(store_id);
  mpgReq.setApiToken(api_token);
  mpgReq.setTransaction(mpiCavvLookup);
  mpgReq.send();

/********************** REQUEST ************************/
  try
  {   
   Receipt receipt = mpgReq.getReceipt();
   System.out.println("ResponseCode = " + receipt.getResponseCode());
   System.out.println("ReceiptId = " + receipt.getReceiptId());
   System.out.println("Message = " + receipt.getMessage());
   System.out.println("ThreeDSServerTransId = " + receipt.getMpiThreeDSServerTransId());
   System.out.println("TransStatus = " + receipt.getMpiTransStatus());
   System.out.println("ChallengeCompletionIndicator = " + 
   receipt.getMpiChallengeCompletionIndicator());

   System.out.println("Cavv = " + receipt.getMpiCavv());
   System.out.println("ECI = " + receipt.getMpiEci());
  } 
  catch (Exception e) 
  { 
   e.printStackTrace();
  }
 }
}
`}
                </pre>
            )

        case _PHP:
            return (
                <pre className="sampleCode">
{`<?php

require "../../mpgClasses.php";

/******************** Request Variables **********************/
$store_id = "`}{this.getValue(storeId, "storeId")}{`";
$api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
//BASE64 Encoded CRes value returned from response at completion of challenge flow.
$cres = "${cres}";
$mpiCavvLookup = new MpiCavvLookup();
$mpiCavvLookup->setCRes($cres);

/******************** Transaction Object **********************/
$mpgTxn = new mpgTransaction($mpiCavvLookup);

/********************** Request Object ************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); 
//"US" for sending transaction to US environment

$mpgRequest->setTestMode(true); 
//false or comment out this line for production transactions

/********************* HTTPS Post Object **********************/
$mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest);

/*********************** Response ****************************/
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nReceiptId = " . $mpgResponse->getReceiptId());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nThreeDSServerTransId = " . $mpgResponse->getMpiThreeDSServerTransId());
print("\\nTransStatus = " . $mpgResponse->getMpiTransStatus());
print("\\nChallengeCompletionIndicator = " . $mpgResponse->getMpiChallengeCompletionIndicator());
print("\\nCavv = " . $mpgResponse->getMpiCavv());
print("\\nECI = " . $mpgResponse->getMpiEci());
?>
`}
                </pre>
            )
        default:
            return null
        }
    }
}

const mapStateToProps = state => {
  const { storeId, apiToken, order_id, cres, onEditId } = state.threeDSTwo.main.config;
  const { selection } = state.common.progLangList;
  return { storeId, apiToken, order_id, cres, selectedProgLangId: selection, onEditId };
}

export default connect(mapStateToProps, {})(CavvLookUpSample)
